<template>
  <div id="app">
    <div class="hamburger-menu" v-if="$store.getters.isAuthenticated || isGuest">
      <input id="menu__toggle" type="checkbox" v-model="sidePanelVisible"/>
      <label class="menu__btn" v-show="$store.state.onMobile" for="menu__toggle">
        <span></span>
      </label>
      <ul class="menu__box" :class="$store.state.sidebarStyleName" id="sidebar-menu">
        <!-- <li v-if="$host.apptitle" class="app-title">
          <router-link to="/calendar" class="menu__item" title="Главная страница">
            <span>{{$host.apptitle}}</span>
          </router-link>
        </li> -->
        <li v-if="$host.apptitle" class="app-title">
          <div class="menu__item">
            <span>
              <img src="./assets/icons/app-icon.svg" class="menu__icon svg-icon" />
            </span>
            <span class="socket-status" :class="{'online': $commonStore.state.$isConnected}"></span>{{$host.apptitle}}
          </div>
        </li>
        <li v-if="isGuest" @click="hideSidebar" class="menu__header">
          <router-link to="/profile" class="menu__item" title="Профиль пользователя">
            <UserProfileIcon class="menu__icon svg-icon" />
            <span>Гость</span>
          </router-link>
        </li>
        <li v-else @click="hideSidebar" class="menu__header">
          <router-link to="/profile" class="menu__item" title="Профиль пользователя">
            <!-- <UserProfileIcon class="menu__icon svg-icon" /> -->
            <div class="menu__icon">
              <AvatarCircle
                v-if="profileData"
                :size="Math.round(remSize * 1.5)"
                :username="profileData.fullName"
                :readonly="true"
                :src="profileData.avatarUrl && profileData.avatarUrl.length ? $host.host + profileData.avatarUrl: null" />
            </div>
            <!-- <span>{{$store.state.userName}}</span> -->
            <span>Профиль</span>
          </router-link>
        </li>
        <li @click="hideSidebar">
          <router-link to="/friends" class="menu__item">
            <UsersIcon class="menu__icon svg-icon" />Друзья
          </router-link>
        </li>
        <li @click="hideSidebar">
          <router-link to="/calendar" class="menu__item">
            <CalendarIcon class="menu__icon" />Календарь
          </router-link>
        </li>
        <!-- <li @click="hideSidebar">
          <router-link to="/dashboard" class="menu__item">
            <BarsChartIcon class="menu__icon" />Dashboard
          </router-link>
        </li>
        <li @click="hideSidebar">  
          <router-link to="/news-sources" class="menu__item">
            <NewsSourcesIcon class="menu__icon" />Источники
          </router-link>
        </li>
        <li @click="hideSidebar">  
          <router-link to="/news-posts" class="menu__item">
            <NewsPostsIcon class="menu__icon svg-icon" />Входящие посты
          </router-link>
        </li>
        <li @click="hideSidebar">
          <router-link to="/submitted-posts" class="menu__item">
            <PaperPlaneIcon class="menu__icon svg-icon" />Отправленные посты
          </router-link>
        </li>
        <li @click="hideSidebar">
          <router-link to="/rejected-posts" class="menu__item">
            <RejectedIcon class="menu__icon svg-icon" />Бракованные посты
          </router-link>
        </li>
        <li @click="hideSidebar">
          <router-link to="/auto-moderated-posts" class="menu__item">
            <AutoModeratedIcon class="menu__icon svg-icon" />Автомодерация постов
          </router-link>
        </li>
        <li v-if="$store.state.onMobile" @click="switchFullScreen">
          <a class="menu__item" title="Перейти в полноэкранный режим">
            <MinMaxIcon class="menu__icon svg-icon" />Во весь экран
          </a>
        </li> -->
        <li v-if="$store.getters.isAuthenticated" @click="hideSidebar(); logoutUser();">
          <router-link to="/" class="menu__item">
            <LogoutIcon class="menu__icon svg-icon" />Выход
          </router-link>
        </li>
        <li v-else @click="hideSidebar(); logoutUser();">
          <router-link to="/login" class="menu__item">
            <LoginIcon class="menu__icon svg-icon" />Войти
          </router-link>
        </li>
      </ul>
    </div>
    <router-view/>
    <!-- Компонент модалки капчи слушает события в фоне -->
    <CaptchaModal />
    <CookieBanner />
    <AuthRequireDialogue />
  </div>
</template>

<script>
import MinMaxIcon from './components/icons/MaximizeIcon';
import LogoutIcon from './components/icons/LogoutIcon';
import LoginIcon  from './components/icons/LoginIcon';
import CaptchaModal from './components/Captcha/CaptchaModal';
import AuthRequireDialogue from './components/AuthRequireDialogue';

export default {
  name: 'App',
  components: {
    MinMaxIcon,
    LogoutIcon,
    LoginIcon,
    CaptchaModal,
    AuthRequireDialogue
  },
  data: () => ({
    sidePanelVisible: false,
    profileData: null,
    remSize: 16
  }),
  computed: {
    // showGuestMenu() {
    //   if (this.$route.path === '/') return true;
    //   return this.$route.path !== '/login' &&
    //     this.$route.path !== '/register';
    // },
    isGuest() {
      return this.$store.state.isGuest;
    }
  },
  watch: {
    $route(to, from) {
      if (to.path === '/') {
        this.sidePanelVisible = true;
      }
    }
  },
  methods: {
    hideSidebar() {
      if (this.$store.state.onMobile) {
        this.sidePanelVisible = false;
      }
    },
    onPushNotification(e) {
      // const data = JSON.parse(e);
      // this.grabberWorkerState = data.value;
    },
    onWindowResize() {
      if (!this.$store.state.onMobile)
        this.sidePanelVisible = true;
    },
    switchFullScreen() {
      const doc = document.documentElement;
      const state = document.webkitIsFullScreen || document.isFullScreen;
      const requestFunc = 
        doc.requestFullscreen ||
        doc.webkitRequestFullScreen ||
        doc.mozRequestFullScreen ||
        doc.msRequestFullScreen;
      const cancelFunc = 
        document.cancelFullScreen ||
        document.webkitCancelFullScreen;
      if (state) {
        cancelFunc.call(document);
      } else {
        requestFunc.call(doc);
      }
    },
    subscribeEvents() {
      if (!this.$isConnected) return;
      try {
        // console.log('Subscribe');
        this.$connection.invoke('Subscribe', 'PushNotifications');
        this.$connection.on('PushNotification', this.onPushNotification);
      }
      catch {}
    },
    unsubscribeEvents() {
      if (!this.$isConnected) return;
      // console.log('Unsubscribe');
      try { this.$connection.invoke('Unsubscribe', 'PushNotifications'); }
      catch {}
    },
    gotoStartPage() {
      this.$router.push('/profile');
    },
    loadProfileData() {
      // выполняем запрос чтобы проверить актуальность access-token
      this.$http.get(`${this.$host.UserServiceApi}`)
      .then((response) => {
        this.updateUserData(response.body);
        this.sidePanelVisible = !this.$store.state.onMobile;
        this.subscribeEvents();
        // if (this.$route.path === '/login' || this.$route.path === '/')
        //   this.gotoStartPage();
      })
      .catch(() => {})
    },
    reloadProfileData() {
      this.$http.get(`${this.$host.UserServiceApi}`)
      .then((response) => {
        this.updateUserData(response.body);
      })
      .catch(() => {})
    },
    updateUserData(data) {
      this.profileData = data;
      this.$store.state.userRole = data.roleType;
      this.$store.state.userId = data.id;
      this.$store.state.userName = data.userName;
      this.$store.state.userRoleName = data.role.name;
      localStorage.setItem('UserRole', data.role);
      localStorage.setItem('UserRoleName', data.role.name);
      localStorage.setItem('UserId', data.id);
      localStorage.setItem('UserName', data.userName);
      localStorage.setItem('FullName', data.fullName);
    },
    onAuthenticated(webToken) {
      this.$store.dispatch('updateWebToken', webToken);
      if (this.$store.getters.isAuthenticated) {
        this.$store.dispatch('setGuest', false);
        this.reloadProfileData();

        if (this.$route.path !== '/' && this.$route.path !== '/profile')
          window.location.href = '/calendar';
      }
    },
    logoutUser() {
      if (this.$store.state.isAuthenticated) {
        this.$store.dispatch('revokeRefreshToken');
      }
      this.$store.dispatch('logout');
    },
    isGuestOrAuthRequired() {
      if (this.isGuest || this.$store.getters.isAuthenticated) return false;

      if (this.$route.path === '/register') return false;
      if (this.$route.path === '/confirm-email-registration') return false;
      if (this.$route.path === '/login') return false;
      if (this.$route.path === '/policy') return false;
      if (this.$route.path === '/legal/termsofuse') return false;
      if (this.$route.path === '/legal/confidentional') return false;

      return true;
    }
  },
  mounted() {
    // 1. Получаем базовый размер шрифта (1rem) в пикселях из тега html
    this.remSize = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
  },
  async created() {
    this.$store.dispatch('setGuest', localStorage.getItem('is-guest'));
    window.addEventListener('resize', this.onWindowResize);
    this.$root.$on('authenticated', this.onAuthenticated);
    this.$root.$on('hideMenuOnMobile', this.hideSidebar);
    this.$root.$on('profile-changed', this.reloadProfileData);

    if (this.$store.getters.isAuthenticated) {
      this.$eventBus.$on('connected', this.subscribeEvents);
      this.loadProfileData();
    }
    else if (this.isGuestOrAuthRequired()) {
      this.sidePanelVisible = false;
      this.$router.push('/login');
      return;
    }

    if (!this.$store.state.onMobile)
      this.sidePanelVisible = true;

    // по умолчанию открываем страницу календаря
    if (window.location.pathname === '/') {
      this.$router.push('/calendar');
    }
  },
  async beforeDestroy() {
    window.removeEventListener('resize', this.onWindowResize);
    this.$root.$off('profile-changed');
    this.$root.$off('authenticated');
    this.$root.$off('hideMenuOnMobile');
    // this.$root.$off('onProfileLoaded'); // ???
    // this.$root.$off('onLogin'); // ???
    this.$eventBus.$off('connected');
    this.unsubscribeEvents();
  }
}
</script>

<style lang='css' scoped src='./assets/css/sidebar.css'>
</style>

<style scoped>
.socket-status {
  display: inline-block;
  vertical-align: top;
  border-radius: 0.25em;
  width: 0.5em;
  height: 0.5em;
  margin-left: -0.75em;
  margin-bottom: auto;
  margin-right: 0.25em;
  background: red;
}
.socket-status.online {
  background: limegreen;
}
</style>